import { Alert } from "swing-components";

import { translate } from "~utils";

export function PotentialPenaltyAlert() {
  return (
    <Alert color="warning" title={translate("CANCEL_POTENTIAL_PENALTY_ALERT_TITLE")} showIcon>
      <p css={{ margin: 0 }}>{translate("CANCEL_POTENTIAL_PENALTY_ALERT_MESSAGE")}</p>
    </Alert>
  );
}
